module.exports = __webpack_public_path__ + "img/step05d__stand_power_bottom_cross - Cop1.5ae8f5f7.png";